import { Game, Platform } from '../types';

const filterByPlatform = (games: Game[], platform: Platform | undefined) => {
    if (platform) return games.filter(game => game.platform.id === platform.id);

    return games;
};

export default filterByPlatform;
